import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface TitleSectionProps {
  asset: DigitalAsset;
}

const TitleSection = ({ asset }: TitleSectionProps) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="bg-white rounded-lg box-shadow">
        <Disclosure.Button className="disclosureBtn ml-2">
          <ChevronRight
            className={`${
              open ? "transform rotate-90" : " text-gray-500"
            } text-gray-500 w-5 h-5 `}
          />
          <span className="disclosureLabel ml-2">Title</span>
        </Disclosure.Button>

        <Disclosure.Panel className="text-xs">
          <div className="grid grid-cols-2 text-xs">
            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Page title:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.page_Title__C && asset.page_Title__C !== "NULL"
                  ? asset.page_Title__C
                  : ""}
              </div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Page title SPA:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.page_Title_Spa__C &&
                asset.page_Title_Spa__C !== "NULL"
                  ? asset.page_Title_Spa__C
                  : ""}
              </div>
            </div>
          </div>
        </Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);

export default TitleSection;